import { Pessoa } from "./pessoa.model"
import { Plano } from "./plano.model"
import { PlanoCategoria } from "./planoCategoria.model"
import { PlanoSituacao } from "./planoSituacao.model"
import { WebIntegrFuncionalidade } from "./webIntegrFuncionalidade.model"

export class WebBloqueioExcecao {
    idSeq: number
    funcionalidade: WebIntegrFuncionalidade
    plano: Plano
    planoCategoria: PlanoCategoria
    planoSituacao: PlanoSituacao
    pessoa: Pessoa
    nrMatricula: string
    icBloqueio: string
    dataBloqueio: Date
    nmMensagem: string
}